<div class="outer-container">
    <div class="row" style="height: 100%">
        <!-- Main content area - dynamically adjust width based on panel state -->
        <div class="col-12 timer-wrapper" *ngIf="showPostcalloutTimer()"><div class="col-12 timer-div">{{showPostcalloutText()}} <label *ngIf="showPostcallAddMoreTimeAlert()" class="label label-add-time" (click)="addMoreTime()">Request More Time</label></div></div>
        <div [ngClass]="isRightPanelCollapsed ? 'col-12' : 'col-9'" style="padding-right: 0; transition: all 0.3s ease;">
            <!-- existing main content here -->
            <div class="console-container">
                <!--Internal Call receive alert start-->
                <!-- <div class="row hdr inboundcallAlert" id="ManualInboundcallAlert" *ngIf="ShowManualInboundcallAlert">
                    <div class="float-start" style="width: 70% !important; float: left; text-align: right; height: 100%">
                        <label>{{ IncomingCallAlerttext }}</label>
                    </div>
                    <div class="float-start" style="width: 30% !important; text-align: right; height: 100%">
                        <label>{{ countdownField }}</label>
                        <button (click)="answerInboundNextCall()" class="btn btn-sm btn-outline-info action-btn-blue mr-1">
                            <img alt=""
                                 _ngcontent-mwn-c81=""
                                 class="group-img ng-star-inserted"
                                 src="{{ baseHref }}/assets/images/icon-inbound.svg"
                                 style="height: 0.813rem" />
                            Answer
                        </button>
                        <button (click)="rejectCall()" class="btn btn-sm btn-outline-info action-btn-blue mr-1">
                            <img alt=""
                                 _ngcontent-mwn-c81=""
                                 class="group-img ng-star-inserted"
                                 src="{{ baseHref }}/assets/images/icon-inbound.svg"
                                 style="height: 0.813rem" />
                            Reject
                        </button>
                    </div>
                </div> -->
                <!--Internal Call receive alert end-->
                <div class="row hdr">
                    <!--[hidden]="showhidebackbtn"-->
                    <div class="row">
                        <div class="col-8">
                            <div class="back" *ngIf="getbackBtn()" [ngClass]="{ disableElement: IsDisableHeader }" (click)="goBack()">
                                <span>&lt;</span> Back to {{ SelectedQueueName ? SelectedQueueName : 'queue' }}
                            </div>
                        </div>
                        <div class="col-4">
                            <!--<app-create-call *ngIf="!IsDisableHeader" [ReadOnly]="ReadOnly"></app-create-call>--><!--Precall status=>7-->
                            <app-create-call *ngIf="getCallPromptStatus()"
                                             [ReadOnly]="getCallPromptControlsActiveStatus()"></app-create-call><!--Precall status=>7-->
                        </div>
                    </div>
                    <div class="col-7">

                        <div class="user-name">
                            {{ userInfo.UserName }}
                        </div>
                        <div class="IVRMessage">
                            <div class="IVRMessageContent">{{ getRequestType() }}</div>
                        </div>
                    </div>
                        <div *ngIf="getDialerType() === 'Keypad' || (this.selectedUserID == 0 &&  !this.showChangeUser && !isReadOnlyCase()) || (this.selectedUserID != 0 && getIsCaseUserUnmapped() &&  !this.showChangeUser && !isReadOnlyCase()) || (this.selectedUserID != 0 && getIsCaseUserUnmapped() &&  !this.showChangeUser )">
                        <div>
                            <div class="chnguser-div" *ngIf="!getHideUnknownContact()">
                                <button class="change-user" (click)="toggleNewUser()">{{ newUser }}</button>
                            </div>
                            <!-- </div> -->
                        </div>
                        <div *ngIf="getshowSearchDialog()"><!--&& this.newUser == 'New User'-->
                            <app-search-dialog (selectedSearchedItem)="updateSelectedAgent($event)"
                                               (notFoundAddNew)="handleSelectedUser($event)" [hideNotFoundButton]="false"></app-search-dialog>
                        </div>
                    </div>

                </div>
                <!-- <hr style="height: 0.063rem; border: 0.063rem solid #97999b; width: 100%" /> -->
                <div *ngIf="IsEnableCall">
                    <!-- <app-create-call></app-create-call> -->
                    <hr style="height: 0.063rem; border: 0.063rem solid #97999b; width: 100%" />
                </div>
                <div style="padding-bottom: 0.063rem; min-height: 60vh" *ngIf="checkIfLoading(menuList)">loading...</div>
                <div class="dynaTabs" *ngIf="menuList.length > 0">
                    <div style="padding-bottom: 0.063rem">
                        <div class="row">
                            <div class="col-10">
                                <div *ngFor="let item of menuList; let i = index">
                                    <a class="sub-info"
                                       [ngClass]="{ active: item.isSelected }"
                                       (click)="menuSelected(item.value)"
                                       *ngIf="!isSubMenuItem(item.value)">{{ item.label }}</a>
                                </div>
                                <div class="ai-suggestion-btn" *ngIf="isCasesTabActive && enableKBChatbot" (click)="openAISuggestion()">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor" style="vertical-align: middle; margin-right: 4px;">
                                        <path d="M12 2l1.5 4.5L18 8l-4.5 1.5L12 14l-1.5-4.5L6 8l4.5-1.5L12 2z"/>
                                        <path d="M19 14l.75 2.25L22 17l-2.25.75L19 20l-.75-2.25L16 17l2.25-.75L19 14z" opacity="0.7"/>
                                        <path d="M5 17l.5 1.5L7 19l-1.5.5L5 21l-.5-1.5L3 19l1.5-.5L5 17z" opacity="0.5"/>
                                    </svg>
                                    AI Suggestion
                                </div>
                            </div>
                            <div class="col-2 text-end">
                                <div class="dropdown dropdown-div">
                                    <button class="submitbtn cd-submit-dropdown btn btn-secondary dropdown-toggle"
                                            [disabled]="(!selectedSubmenu && formDataValid && !disableSubmitButton ? false : true) || isSubmittingCaseDetails || isButtonsReadOnlyMode"
                                            type="button"
                                            (click)="getAllDynamicFormData(); toggleSubmitDropdown($event)">
                                        Submit
                                    </button>
                                    <ul class="dropdown-menu">
                                        <li [ngClass]="{ disableElement: isSubmittingCaseDetails }">
                                            <a class="dropdown-item" (click)="onSubmit()">Submit <br /><span class="subText">Submit the call and continue</span></a>
                                        </li>
                                        <li *ngIf="showSubmitPause()" [ngClass]="{ disableElement: IsDisableSubmitPauseButton || isSubmittingCaseDetails }">
                                            <a class="dropdown-item" (click)="onSubmit('pause')">
                                                Submit & Pause<br /><span class="subText">
                                                    Submit the call but pause before the next <br />call. Will set your status to "Away"
                                                </span>
                                            </a>
                                        </li>
                                        <li *ngIf="!currentActionItemConfData?.Response?.Data?.HideSubmitFollowup" [ngClass]="{ disableElement: isSubmittingCaseDetails }">
                                            <a class="dropdown-item" (click)="onSubmit('followup')">
                                                Submit & Follow Up <br /><span class="subText">
                                                    the call but stay on the same user record.
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="col-12 text-danger err-message">{{ errorMessage }}</div> -->
                    <hr style="height: 0.063rem; border: none; border-top: 0.063rem solid #97999b; width: 100%; margin: 0rem" />

                    <div class="submenu-heading-div" *ngIf="subMenulstSelected && subMenulstSelected.length > 0">
                        <ng-container *ngFor="let submenu of subMenulstSelected; let k = index">
                            <div class="submenu-heading"
                                 [ngClass]="{ submenuactive: submenu.IsSelected, submenudisable: submenu.IsDisabled }"
                                 (click)="SubMenuSelected(k)">
                                {{ submenu.Label }}
                            </div>
                        </ng-container>
                    </div>

                    <div *ngFor="let submenu of subMenulstSelected; let k = index">
                        <div *ngIf="submenu.Name === 'memberInformation'">
                            <app-member-information *ngIf="submenu.Name === selectedSubmenu"
                                                    [FieldsConf]="getConfByTabName(selectedSubmenu)"
                                                    [ReadOnly]="isReadOnlyCase()">
                            </app-member-information>
                        </div>
                        <div *ngIf="submenu.Name === 'providerInformation'">
                            <app-provider-information *ngIf="submenu.Name === selectedSubmenu"
                                                      [FieldsConf]="getConfByTabName(selectedSubmenu)"
                                                      [ReadOnly]="isReadOnlyCase()">
                            </app-provider-information>
                        </div>
                        <div *ngIf="submenu.Name === 'claims'">
                            <app-claims *ngIf="submenu.Name === selectedSubmenu"
                                        [FieldsConf]="getConfByTabName(selectedSubmenu)"
                                        [ReadOnly]="isReadOnlyCase()">
                            </app-claims>
                        </div>
                    </div>

                    <div *ngFor="let item of menuList; let i = index">
                        <div *ngIf="hasPredefinedTemplate(item.value); else defaultTemplate">
                            <div *ngIf="item.value === 'cases'">
                                <app-cases *ngIf="item.value === selectedTab"
                                           [conf]="getConfByTabName(selectedTab)"
                                           (formDataEmitter)="onChildFormData($event, selectedTab)"
                                           (formDataHasError)="handleFormDataHasError($event, selectedTab)"
                                           [caseDetailsConf]="caseDetailsConf"
                                           [tabName]="selectedTab"
                                           [selectedCaseId]="selectedCaseId"
                                           [newUserCases]="newUserCases"
                                           (newCases)="UpdateNewCases($event)"
                                           [userId]="getSelectedUserID()"
                                           (setCaseID)="UpdateSelectedCaseID($event)"
                                           [crmUserID]="crmUserID"
                                           (isUserLevelLocked)="IsUserLevelLocked($event)">
                                </app-cases>
                            </div>
                            <div *ngIf="item.value === 'memberInformation'">
                                <app-member-information *ngIf="item.value === selectedTab"
                                                        [FieldsConf]="getConfByTabName(selectedTab)"
                                                        [ReadOnly]="isReadOnlyCase()">
                                </app-member-information>
                            </div>
                            <div *ngIf="item.value === 'disposition'">
                                <app-disposition-and-notes *ngIf="item.value === selectedTab"
                                                           [conf]="getConfByTabName(selectedTab)"
                                                           (formDataEmitter)="onChildFormData($event, selectedTab)"
                                                           (formDataHasError)="handleFormDataHasError($event, selectedTab)"
                                                           (isDisableSubmitPause)="disableSubmitPauseButton($event)"
                                                           [caseDetailsConf]="caseDetailsConf"
                                                           [tabName]="selectedTab"
                                                           [ReadOnly]="isUserLevelLocked">
                                </app-disposition-and-notes>
                            </div>
                            <div *ngIf="item.value === 'userInformation' && !hideUserInformationTab">
                                <app-user-information *ngIf="item.value === selectedTab"
                                                      style="display: grid"
                                                      [userData]="searchedUserData"
                                                      [conf]="getConfByTabName(selectedTab)"
                                                      (formDataEmitter)="onChildFormData($event, selectedTab)"
                                                      (formDataHasError)="handleFormDataHasError($event, selectedTab)"
                                                      (ConfirmUserNav)="confirmUserNav($event)"
                                                      [caseDetailsConf]="caseDetailsConf"
                                                      [tabName]="selectedTab"
                                                      [ReadOnly]="isReadOnlyCase()"
                                                      [showChangeUser]="showChangeUser">
                                </app-user-information>
                            </div>
                            <div *ngIf="item.value === 'fax'">
                                <app-communication-history *ngIf="item.value === selectedTab"
                                                           [conf]="getConfByTabName(selectedTab)"
                                                           (formDataEmitter)="onChildFormData($event, selectedTab)"
                                                           [ReadOnly]="isReadOnlyCase()"></app-communication-history>
                            </div>
                        </div>

                        <ng-template #defaultTemplate>
                            <!--Default template-->
                            <app-dynamic-tab-view *ngIf="item.value === selectedTab"
                                                  [conf]="getConfByTabName(selectedTab)"
                                                  (formDataEmitter)="onChildFormData($event, selectedTab)"
                                                  (formDataHasError)="handleFormDataHasError($event, selectedTab)"
                                                  [caseDetailsConf]="caseDetailsConf"
                                                  [tabName]="selectedTab"
                                                  [ReadOnly]="isReadOnlyCase()"></app-dynamic-tab-view>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>

        <!-- Right panel with collapse functionality -->
        <div [ngClass]="isRightPanelCollapsed ? 'col-0 collapsed-panel' : 'col-3'"
             class="right-panel-container"
             style="
        padding-right: 0;
        padding-left: 0;
        background: transparent url('{{baseHref}}/assets/images/rectangle.svg') 0% 0% no-repeat padding-box;
        background-size: cover;
        transition: all 0.3s ease;
        position: relative;
        margin-top: 2px;
      ">
            <!-- Collapse/Expand Toggle Button -->
            <button class="panel-toggle-btn"
                    (click)="toggleRightPanel()"
                    [title]="isRightPanelCollapsed ? 'Expand Panel' : 'Collapse Panel'">
                <i [ngClass]="isRightPanelCollapsed ? 'pi pi-angle-left' : 'pi pi-angle-right'"></i>
            </button>
           
<div style="height: 2rem; display: flex; align-items: center; justify-content: right;padding: 10px;color: rgb(102, 102, 102)">
 <span [ngStyle]="{ 'font-weight': isCallOnHold ? 'bold' : 'normal' }">
  Hold Duration: {{ holdCallDuration }}
</span> 
</div>

            <!-- Right Panel Content -->
            <div class="rightPanel" [ngClass]="{'panel-hidden': isRightPanelCollapsed}">
                <nav class="navbar navbar-expand-lg">
                    <ul class="navbar-nav">
                        <li class="nav-item"
                            *ngFor="let item of rightPanelTabs; let i = index"
                            [ngClass]="{ active: item.isSelected }"
                            [style.display]="item.isDisabled ? 'none' : 'block'"
                            (click)="rightPanelTabClick(item)">
                            <a class="nav-link"
                               style="
                  font-weight: 700;
                  font-size: 0.813rem;
                  line-height: 0.938rem;
                  font-family: Gellix, sans-serif;
                  letter-spacing: 0rem;
                  color: #53565a;
                  opacity: 1;
                  padding-left: 1.2rem;
                  padding-right: 1.2rem;
                "
                               aria-current="page">{{ item.label }}</a>
                        </li>
                    </ul>
                </nav>

                <!-- Panel Content Sections -->
                <div class="container" *ngIf="activeRightPanelTab === 0">

                    <!-- Existing working Audio -->
                    <div class="row">
                        <div *ngIf="isRecordLoaded">
                            <app-videojs-wavesurfer
                                [recordingDetails]="recordingDetails"
                                [index]="recordingIndex">
                            </app-videojs-wavesurfer>
                        </div>
                
                        <div class="audio-loading" *ngIf="!isRecordLoaded">
                            Loading Audio
                        </div>
                    </div>
                
                
                    <!-- New Details / Transcript sub tabs -->
                    <div class="voicemail-sub-tabs">
                
                        <div
                            class="voicemail-sub-tab"
                            [ngClass]="{ active: activeVoiceMailTab === 'details' }"
                            (click)="activeVoiceMailTab = 'details'">
                            Details
                        </div>
                
                        <div
                            class="voicemail-sub-tab"
                            [ngClass]="{ active: activeVoiceMailTab === 'transcript' }"
                            (click)="activeVoiceMailTab = 'transcript'">
                            Transcript
                        </div>
                
                    </div>
                
                
                    <!-- Existing Details -->
                    <div
                        class="row mt-3"
                        *ngIf="activeVoiceMailTab === 'details'">
                
                        <div
                            class="voicemaildiv"
                            *ngFor="let data of displayVoiceMailDetails">
                
                            <label class="col-5 voicemailLabel">
                                {{ data.label }}
                            </label>
                
                            <label class="col-7 voicemailvalue">
                                {{ data.value }}
                            </label>
                
                        </div>
                
                    </div>
                
                
                    <!-- New Transcript -->
                    <div
                        class="voicemail-transcript"
                        *ngIf="activeVoiceMailTab === 'transcript'">
                
                        <div class="voicemail-transcript-header">
                
                            <span class="transcript-speaker">
                                {{ voicemailTranscriptSpeaker }}
                            </span>
                
                            <span class="transcript-date">
                                {{ voicemailTranscriptDate }}
                            </span>
                
                        </div>
                
                        <div class="voicemail-transcript-text">
                            {{ voicemailTranscript }}
                        </div>
                
                    </div>
                
                </div>
                <!-- <div class="container" *ngIf="activeRightPanelTab === 0"> -->
                    <!-- Audio/Recording content -->
                    <!-- <div class="row">
                        <div *ngIf="isRecordLoaded">
                            <app-videojs-wavesurfer [recordingDetails]="recordingDetails"
                                                    [index]="recordingIndex"></app-videojs-wavesurfer>
                        </div>
                        <div class="audio-loading" *ngIf="!isRecordLoaded">Loading Audio</div>
                    </div>
                    <div class="row mt-3">
                        <div class="voicemaildiv" *ngFor="let data of displayVoiceMailDetails">
                            <label class="col-5 voicemailLabel">{{ data.label }}</label>
                            <label class="col-7 voicemailvalue">{{ data.value }}</label>
                        </div>
                    </div> -->
                <!-- </div> -->

                <!-- Call History Section -->
                <div class="container" *ngIf="activeRightPanelTab === 1">
                    <!-- Follow-up item and call history content -->
                    <div *ngIf="followUpItem" class="followup-item">
                        <span>
                            Follow-Up scheduled for
                            {{
                checkCurrentDay(followUpItem.FollowUpDate) ? 'today' : (followUpItem.FollowUpDate | custdateonly)
                            }}
                            at {{ followUpItem.FollowUpDate | custdate | date: 'hh:mm a' }} by {{ followUpItem.Caller }}
                        </span>
                    </div>
                    <div class="row mt-2 mb-1">
                        <!-- <div class="col-12">
                            <input
                                type="text"
                                class="form-control form-control-sm"
                                placeholder="Search by Case ID, Interaction, Agent, Disposition…"
                                [(ngModel)]="callHistorySearchTerm"
                                style="font-size: 0.75rem;margin-bottom: 0.75rem" />
                        </div> -->
                  <div class="search-container">
                  <input
                   type="text"
                   id="callHistorySearch"
                   name="callHistorySearch"
                   class="form-control form-control-sm"
                   placeholder="Search by Case ID"
                    [(ngModel)]="callHistorySearchTerm"
                   (ngModelChange)="onCaseHistorySearchChange()"  (keyup.enter)="searchCallHistoryByCaseId()" style="font-size: 0.76rem;"/>

                    <span
                      class="clear-x"
                      *ngIf="callHistorySearchTerm"
                      (click)="!loading && clearCaseHistorySearch()">
                      ×
                    </span>
                    <button
                      class="search-btn"
                      (click)="searchCallHistoryByCaseId()">
                      <img alt="" class="search-img" src="{{ baseHref }}/assets/images/icon-search.svg" />
                    </button>
                  </div>
                    </div>
                    <div class="row">
                        <div class="col-7">
                            <div style="
                  text-align: left;
                  font-weight: 500;
                  font-size: 0.75rem;
                  line-height: 0.875rem;
                  font-family: Gellix, sans-serif;
                  letter-spacing: 0rem;
                  color: #000048;
                  opacity: 1;
                ">
                                <!-- Showing {{ callHistory ? (callHistory.length > 0 ? first + rows : 0) : 0 }} of
                                {{ TotalItemCount }} items -->
                                Showing {{ filteredCallHistory?.length }} of {{ TotalItemCount }} items
                            </div>
                        </div>
                        <div class="col-5">
                            <div style="
                  text-align: left;
                  text-align: right;
                  font-weight: 500;
                  font-size: 0.625rem;
                  line-height: 0.75rem;
                  font-family: Gellix, sans-serif;
                  letter-spacing: 0rem;
                  color: #2f78c4;
                  opacity: 1;
                ">
                                <span (click)="collapseAll = !collapseAll" style="cursor: pointer"> Expand/Collapse All </span>
                            </div>
                        </div>
                    </div>
                    <hr style="height: 0.063rem; margin-top: 0.5rem; border: 0.063rem solid #97999b; width: 100%" />
                </div>

                <div class="container" *ngIf="activeRightPanelTab == 1">
                    <div *ngFor="let item of filteredCallHistory" class="mb3">
                        <p-panel [toggleable]="true"
                                 [collapsed]="!collapseAll"
                                 [collapseIcon]="'pi pi-plus-circle'"
                                 [expandIcon]="'pi pi-minus-circle'">
                            <ng-template pTemplate="header">
                                <div>
                                    <p style="
                      text-align: left;
                      font-weight: bold;
                      font-size: 0.75rem;
                      line-height: 0.875rem;
                      font-family: Gellix, sans-serif;
                      letter-spacing: 0rem;
                      padding-top: 1.25rem;
                      color: #53565a;
                      opacity: 1;
                    ">
                                        {{ item.Date | custdate }}
                                        <br />
                                        <span style="
                        text-align: left;
                        font-weight: 500;
                        font-size: 0.75rem;
                        line-height: 0.875rem;
                        font-family: Gellix, sans-serif;
                        letter-spacing: 0rem;
                        color: #53565a;
                        opacity: 1;
                      ">
                                            {{ item.custTtype }} - {{ item.Disposition }}
                                        </span>
                                    </p>
                                </div>
                            </ng-template>
                            <div class="row" style="font-size: 0.75rem;">
                                <div class="col-12 mb3">
                                    <label style="width: 4rem">Interaction</label>
                                    <span> : </span>
                                    <span>{{ item.ID }}</span>
                                </div>
                                <div class="col-12 mb3">
                                    <label style="width: 4rem">Case ID</label>
                                    <span> : </span>
                                    <span> {{ item.CaseID === 0 ? 'NA' : item.CaseID }}</span>
                                </div>
                                <div class="col-12 mb3">
                                    <label style="width: 4rem">Agent</label>
                                    <span> : </span>
                                    <!-- <span class="comments"> {{ item.Caller }}</span> -->
                                    <span> {{ item.Caller }}</span>
                                </div>
                                <div class="col-12 mb3">
                                    <label style="width: 4rem"># Called</label>
                                    <span> : </span>
                                    <span> {{ item.NumberCalled }}</span>
                                </div>
                                <div class="col-12 mb3"
                                     *ngIf="item.Recording != null && item.Recording.includes(this.clientAbbreviation)">
                                    <label style="width: 4rem">Recordings</label>
                                    <span>:</span><button class="action-btn playAudioBtn" (click)="playAudio(item)">Play</button>
                                </div>
                                <div class="col-12 mb3"
                                     *ngIf="item.Recording != null && item.Recording.includes(this.clientAbbreviation)">
                                    <span>
                                        <audio id="myAudio_{{ item.ID }}_{{ item.CaseID }}" style="width: 90%; display: none" controls>
                                            <source v-bind:src="" />
                                            Your browser does not support the audio.
                                        </audio>
                                    </span>
                                </div>
                                <div class="col-12 mb3">
                                    <label style="width: 4rem">Comments</label>
                                    <span> : </span>
                                    <!-- <span class="comments" [innerHTML]=""> {{ item.Comments }}</span> -->
                                    <span class="comments" [innerHTML]="item.Comments"></span>
                                </div>
                                <div class="col-12 mb3" *ngIf="item.EnablePostCallTranscript">
                                    <div class="btn-wrapper text-center">
                                        <button class="outline-btn ms-2"
                                                type="submit"
                                                value="View Transcript"
                                                (click)="viewTranscript(item)">
                                            View Transcript
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </p-panel>
                    </div>
                    <p-paginator (onPageChange)="onPageChange($event)"
                                 [first]="first"
                                 [rows]="rows"
                                 [totalRecords]="paginatorTotalRecords" />
                </div>

                <div class="container" *ngIf="activeRightPanelTab == 2">
                    <div style="padding-top: 0.625rem">
                        <div class="row">
                            <div class="col-9">
                                <div style="
                    text-align: left;
                    font-weight: 500;
                    font-size: 0.75rem;
                    line-height: 0.875rem;
                    font-family: Gellix, sans-serif;
                    letter-spacing: 0rem;
                    color: #53565a;
                    opacity: 1;
                  ">
                                    {{ scriptInfo }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- transcript start -->
                <div class="container" *ngIf="activeRightPanelTab == 3">
                    <div style="padding-top: 0.625rem">
                        <div class="row">
                            <div class="col-12">
                                <div class="container"
                                     style="
                    text-align: left;
                    font-weight: 500;
                    font-size: 0.75rem;
                    line-height: 0.875rem;
                    font-family: Gellix, sans-serif;
                    letter-spacing: 0rem;
                    color: #53565a;
                    opacity: 1;
                  ">
                                    <app-call-transcript></app-call-transcript>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- transcript end -->
            </div>
        </div>
        <!-- row -->
    </div>
    <!-- <app-dialer
      (endCall)="endCall()"
      (muteMic)="muteMic()"
      [showDialer]="showDialer"
      [callStatus]="callStatus"
      [phoneNo]="phoneNo"
      [waitingForInboundCall]="waitingForInboundCall"
      style="width: 180px"
    ></app-dialer> -->

    <div class="cd-modal">
        <div class="modal" [ngStyle]="{ display: display }">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header menu" style="border-radius: 0">
                        <span class="menu-heading" *ngIf="!errorMessage"> Invalid Fields </span>
                        <span class="menu-heading" *ngIf="errorMessage"> Error </span>
                        <span class="close" (click)="onCloseHandled()">X</span>
                    </div>
                    <div class="modal-body">
                        <ul *ngIf="invalidFields.length > 0 || invalidCaseFields.length > 0">
                            <li *ngFor="let item of invalidCaseFields">
                                <label><strong>Case {{ item.caseId }} </strong></label>
                                {{ item.fieldName }} is invalid.
                            </li>
                            <li *ngFor="let item of invalidFields">
                                <label>
                                    <strong>{{ item.tab }}</strong>
                                </label>
                                {{ item.field.Name }} is invalid
                            </li>
                        </ul>
                        <p class="text-danger" *ngIf="errorMessage">{{ errorMessage }}</p>
                    </div>
                    <div class="modal-footer" style="justify-content: center">
                        <button type="button" [ngClass]="'done-btn-active'" (click)="onCloseHandled()">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--
    keypad start -->
    <div class="kp-modal">
      <div *ngIf="getkeypadCallPromptStatus()"
          class="modal d-block"
          tabindex="-1"
          style="position: absolute; top: 10.3rem; left: 15px; width: 73.7%; height: 100%">
          <div class="modal-dialog">
              <div class="modal-content" style="border-radius: 1 !important">
                  <div class="dialpad-container" [ngClass]="{ readonly: getCallPromptControlsActiveStatus() }">
                      <div class="row">
                          <div class="col-6">
                              <span class="heading">{{ getCallStatus() }}</span>
                          </div>
                          <div class="col-6 text-end">
                              <div class="icon-box">
                                  <span *ngIf="dialpad">
                                      <img src="{{ baseHref }}/assets/images/dialer/dialer-active.svg"
                                          class="contact-icon"
                                          alt="numpad"
                                          tabindex="2"
                                          style="border-radius: 3px 0 0 3px"
                                          (click)="showDialpad()"
                                          [ngStyle]="{ 'background-color': dialpad == true ? '#2E308E' : '#D0D0CE' }" />
                                  </span>
                                  <span *ngIf="!dialpad">
                                      <img src="{{ baseHref }}/assets/images/dialer/dialer.svg"
                                          class="contact-icon"
                                          alt="numpad"
                                          tabindex="2"
                                          style="border-radius: 3px 0 0 3px"
                                          (click)="showDialpad()"
                                          [ngStyle]="{ 'background-color': dialpad == true ? '#2E308E' : '#D0D0CE' }" />
                                  </span>
                                  <span *ngIf="addressBook">
                                      <img src="{{ baseHref }}/assets/images/dialer/icon-dialer-contact-book-active.svg"
                                          class="contact-icon"
                                          alt="call"
                                          tabindex="1"
                                          style="border-radius: 0 3px 3px 0"
                                          (click)="showAddressBook()"
                                          [ngStyle]="{ 'background-color': addressBook == true ? '#2E308E' : '#D0D0CE' }" />
                                  </span>
                                  <span *ngIf="!addressBook">
                                      <img src="{{ baseHref }}/assets/images/dialer/icon-dialer-contact-book-inactive.svg"
                                          class="contact-icon"
                                          alt="call"
                                          tabindex="1"
                                          style="border-radius: 0 3px 3px 0"
                                          (click)="showAddressBook()"
                                          [ngStyle]="{ 'background-color': addressBook == true ? '#2E308E' : '#D0D0CE' }" />
                                  </span>

                                  <!-- <span>

                                    <img src="{{ baseHref }}/assets/images/dialer/dialer-active.svg" class="contact-icon" alt="numpad"
                                      tabindex="2" style="border-radius: 3px 0 0 3px;" (click)="showDialpad()"
                                      [ngStyle]="{'background-color': (dialpad==true) ? '#2E308E' : '#D0D0CE'}" />
                                    <img src="{{ baseHref }}/assets/images/dialer/icon-dialer-contact-book-active.svg" class="contact-icon"
                                      alt="call" tabindex="1" style="border-radius:  0 3px 3px 0;" (click)="showAddressBook()"
                                      [ngStyle]="{'background-color': (addressBook==true) ? '#2E308E' : '#D0D0CE'}" />
                                  </span> -->
                              </div>
                          </div>
                      </div>

                      <div class="main-keypad">
                          <!-- Dialpad -->
                          <div class="row" *ngIf="dialpad">
                              <div class="col-12">
                                  <div class="input-group">
                                      <input class="form-control dial-input"
                                            type="text"
                                            [(ngModel)]="inputValue"
                                            style="border: none; background: transparent" />
                                      <button class="backspace-icon"
                                              (click)="onBackspace()"
                                              style="border: none; background: transparent; margin: 0px 8px 0px 0px">
                                          <img alt="" class="backspace-icon" src="{{ baseHref }}/assets/images/dialer/icon-backspace.svg" />
                                      </button>
                                  </div>
                                  <hr class="hrRow" />
                              </div>
                              <div class="col-12">
                                  <div class="keypad-row row">
                                      <!-- <div *ngIf="keypad"> -->
                                      <ng-container *ngFor="let item of numberPad">
                                          <div class="keypad" (click)="onNumberPadBtnClick(item.number)">
                                              <div class="digits">{{ item.digit }}</div>
                                              <div class="numbers">{{ item.number }}</div>
                                          </div>
                                      </ng-container>
                                      <!-- </div> -->
                                  </div>
                                  <div class="text-center" style="padding-top: 6px">
                                      <img src="{{ baseHref }}/assets/images/icon-dial-call-green-reverse.svg"
                                          class="call"
                                          alt="call"
                                          tabindex="1"
                                          (click)="StartOutboundCall()"
                                          (keydown.enter)="StartOutboundCall()" />
                                  </div>
                              </div>
                          </div>

                          <!--Address book-->
                          <div class="row" *ngIf="addressBook">
                              <div class="col-12">
                                  <div class="overFlow">
                                      <div *ngFor="let item of contactNumList" (click)="StartCallActivity(item)">
                                          <div class="row">
                                              <div class="col-10" style="padding: 0 0 0 15px">
                                                  <p style="
                              text-align: left;
                              font-weight: bold;
                              font-size: 0.75rem;
                              line-height: 0.875rem;
                              font-family: Gellix, sans-serif;
                              letter-spacing: 0rem;
                              /* padding-top: 1.25rem; */
                              color: #000048;
                              opacity: 1;
                            ">
                                                      {{ item.Name }}
                                                      <br />
                                                      <span class="lang">English</span>
                                                      <br />
                                                      <span style="
                                text-align: left;
                                font-weight: 500;
                                font-size: 0.75rem;
                                line-height: 0.875rem;
                                font-family: Gellix, sans-serif;
                                letter-spacing: 0rem;
                                color: #53565ad9;
                                opacity: 1;
                              ">
                                                          {{ item.Number }}
                                                      </span>
                                                  </p>
                                              </div>
                                              <div class="col-2">
                                                  <span class="text-end"
                                                        style="
                              font-size: 0.75rem;
                              line-height: 0.875rem;
                              color: #2e2f6a;
                              opacity: 1;
                              margin: 0 0 0 -15px;
                            ">
                                                      <img src="{{ baseHref }}/assets/images/dialer/icon-dial.svg"
                                                          class="call"
                                                          alt="call"
                                                          tabindex="1"
                                                          (click)="StartOutboundCallFromContact(item)" />
                                                  </span>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>

                  <!-- <div class="modal-header">
                    <h5 class="modal-title">Scoped Modal</h5>
                    <button type="button" class="btn-close" (click)="closeModal()"></button>
                  </div> -->
                  <!-- <div class="modal-body">
                    <p>This modal is scoped only to this section.</p>
                  </div> -->
                  <!-- <div class="modal-footer">
                    <button class="btn btn-secondary" (click)="closeModal()">Close</button>
                  </div> -->
              </div>
          </div>
      </div>
    </div>

    <!-- keypad end -->
    <!--Call failure modal popup-->
    <!-- Phone Validation Modal -->
    <div class="case-detail-phone-modal" *ngIf="getValidationModalStatus()">
        <div class="pv-modal modal-overlay">
            <div class="modal fade show" [ngStyle]="{ display: getDisplayvalidationModal() }" tabindex="-1" role="dialog" aria-modal="true">
                <div class="modal-backdrop fade show"></div>
                <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header menu" style="border-radius: 0">
                        <span class="menu-heading">Error - Call Failed</span>
                        <span class="close" (click)="closeValidationModal()">X</span>
                    </div>
                    <div class="modal-body">
                        <p class="text-danger" style="font-size: 0.875rem;">The call was unsuccessful - {{ getvalidationErrorMessage() }}</p>
                        <p>Please verify the call disposition and add notes if desired. Or, try calling later.</p>
                        <div class="modal-disposition">
                            <div class="input-data">
                                <label for="callDisposition">Call Disposition</label>
                                <select name="callDisposition"
                                        [(ngModel)]="selectedCallDisposition"
                                        id="callDisposition"
                                        style="background-color: #f8f9fb">
                                    <option *ngFor="let option of callDispositionOptions" [ngValue]="option">
                                        {{ option.label }}
                                    </option>
                                </select>
                            </div>
                            <div class="input-data mt-3">
                                <label for="callNotes" style="margin-top: 2rem;">Notes</label>
                                <textarea name="callNotes"
                                          [(ngModel)]="callNotes"
                                          id="callNotes"
                                          rows="3"
                                          placeholder="Add any additional notes about the call..."
                                          style="background-color: #f8f9fb"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer" style="justify-content: center">
                        <button type="button"
                                class="submit-call-btn"
                                [disabled]="!isValidDispositionSelected()"
                                (click)="submitFailure()">
                            Submit Call
                        </button>
                        <!-- <button type="button" class="done-btn-active" (click)="closeValidationModal()">Close</button> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--call failure modal popup end-->
</div>


<!-- Disposition timeout modal -->
<div class="disposition-timeout-modal" *ngIf="showDispositionTimeoutModal">
    <div class="timeout-modal modal-overlay">
        <div class="modal fade show"  [ngStyle]="{ display: showDispositionTimeoutModal ? 'block' : 'none' }" tabindex="-1" role="dialog" aria-modal="true">
            <div class="modal-backdrop fade show"></div>
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header menu" style="border-radius: 0">
                        <span class="menu-heading">Submit Record</span>
                    </div>
                    <div class="modal-body">
                        <p style="font-size: 0.875rem; text-align: center; margin: 20px 0;">
                            You failed to submit the record in the allowed time.
                        </p>
                        <p style="font-size: 0.875rem; text-align: center; margin: 20px 0;">
                            Please press OK to finish submitting the record. 
                        </p>
                    </div>
                    <div class="modal-footer" style="justify-content: center">
                        <button type="button"
                                class="timeout-ok-btn"
                                (click)="closeDispositionTimeoutModal()">
                            OK
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--disposition timeout modal end-->
<!-- console-container -->
